import type { Config } from 'tailwindcss';
import resolveConfig from 'tailwindcss/resolveConfig';
import { tailwindConfigBase } from './tailwind.config.base';

/**
 * All values of config resolved, it means that for example all default
 * theme properties are merged with our custom properties. You can use
 * it for referencing values.
 */
export const resolvedConfig = resolveConfig(
  tailwindConfigBase,
) satisfies Config;
